const BYTES_PER_MEGABYTE = 1048576;
export const UploadFileHelper = {
    isValidFileExtension(fileType, allowedMimeTypes) {
        return allowedMimeTypes.includes(fileType);
    },
    isValidFileSize(fileSize, maxSize) {
        return fileSize <= maxSize;
    },
    convertByteToMegabyte(byte) {
        return byte / BYTES_PER_MEGABYTE;
    }
};
